import styled from 'styled-components'
import { VerticalStyledScrollBar } from '~/styles'

export const Container = styled.div.attrs(props => ({
  scrollbarBackground: props.theme.zds.colors.neutral1000
}))`
  width: 100%;
  height: fit-content;
  max-height: calc(100vh - 226px);

  background-color: ${({ theme }) => theme.zds.colors.neutral1000};
  border-radius: ${({ theme }) => theme.zds.border.radius100};

  overflow-y: auto;
  ${VerticalStyledScrollBar}
`

export const ContainerAlert = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  > span {
    text-align: center;
    color: ${props => props.theme.colors.color122d52};
    font-size: 0.875rem;
  }

  b {
    font-weight: 700;
  }
`

export const HeaderLayout = styled.header`
  position: relative;
  width: 100%;
  padding: 1rem;

  display: flex;
  align-items: center;
  gap: 2rem;
`

export const HeaderContentBlock = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const Label = styled.span`
  font-family: 'Inter';
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;

  color: ${props => props.theme.colors.color545e6c};
`

export const Value = styled.p`
  font-family: 'Inter';
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;

  color: ${props => props.theme.colors.color2d3139};
`

export const Divisor = styled.div`
  position: relative;
  margin: 0 1rem;
  height: 1px;
  background: ${props => props.theme.colors.coloreceff4};
`

export const TitleInformation = styled.h2`
  font-family: 'Inter';
  margin-right: 2rem;
  font-weight: 500;
  font-size: 22px;
  line-height: 19px;

  color: ${props => props.theme.colors.color122d52};
`

export const ContentLayout = styled.div`
  width: 100%;
  padding: 2rem 1rem;

  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 2rem;
`

export const ContentBlock = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const SubTitleInformations = styled.div`
  position: relative;
  margin-top: 8px;
  margin-bottom: 20px;

  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const ChartArea = styled.div`
  width: 100%;
  height: 45vh;
  margin-bottom: 1rem;
`

export const ChartFooterLabel = styled(Label)`
  text-align: right;
  padding-right: 1rem;
`

export const ChartDescription = styled.p`
  font-family: 'Inter';
  font-weight: 400;
  font-size: 14px;
  line-height: 12px;
  color: ${props => props.theme.colors.color545e6c};
`

export const ChartLegend = styled.button`
  position: relative;

  display: flex;
  align-items: center;
  gap: 0.5rem;

  background: transparent;
  border: none;
  cursor: pointer;
`

export const LegendItem = styled.div`
  width: 12px;
  height: 12px;
  background: ${props => props.theme.colors.color005597};
  border-radius: 50%;
`
